import {
  addDays,
  addMonths,
  addWeeks,
  endOfDay,
  endOfWeek,
  startOfDay,
  startOfWeek,
} from 'date-fns';

export type WindowPreset =
  | 'TODAY'
  | 'THIS_WEEK'
  | 'NEXT_2_WEEKS'
  | 'NEXT_1_MONTH'
  | 'NEXT_2_MONTHS'
  | 'CUSTOM';

export interface DateWindow {
  start: string;
  end: string;
}

const toIso = (date: Date): string => date.toISOString();

export const getPresetRange = (
  preset: WindowPreset,
  reference: Date = new Date()
): DateWindow => {
  const today = startOfDay(reference);

  switch (preset) {
    case 'TODAY':
      return { start: toIso(today), end: toIso(endOfDay(reference)) };
    case 'THIS_WEEK':
      return {
        start: toIso(startOfWeek(reference, { weekStartsOn: 1 })),
        end: toIso(endOfWeek(reference, { weekStartsOn: 1 })),
      };
    case 'NEXT_2_WEEKS':
      return { start: toIso(today), end: toIso(endOfDay(addWeeks(today, 2))) };
    case 'NEXT_1_MONTH':
      return { start: toIso(today), end: toIso(endOfDay(addMonths(today, 1))) };
    case 'NEXT_2_MONTHS':
      return { start: toIso(today), end: toIso(endOfDay(addMonths(today, 2))) };
    case 'CUSTOM':
    default:
      return { start: toIso(today), end: toIso(endOfDay(addDays(today, 14))) };
  }
};

export const presetLabel: Record<WindowPreset, string> = {
  TODAY: 'Today',
  THIS_WEEK: 'This week',
  NEXT_2_WEEKS: 'Next 2 weeks',
  NEXT_1_MONTH: 'Next 1 month',
  NEXT_2_MONTHS: 'Next 2 months',
  CUSTOM: 'Custom range',
};

export const daysBetween = (fromIso: string, toIso: string): number => {
  const from = new Date(fromIso).getTime();
  const to = new Date(toIso).getTime();
  return Math.round((to - from) / (1000 * 60 * 60 * 24));
};
